import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Rebirthing from "@/pages/public/Rebirthing";
import Retreats from "@/pages/public/Retreats";
import RetreatDetail from "@/pages/public/RetreatDetail";
import Dubbi from "@/pages/public/Dubbi";
import Volunteer from "@/pages/public/Volunteer";
import Contact from "@/pages/public/Contact";
import Donate from "@/pages/public/Donate";
import PaymentSuccess from "@/pages/public/PaymentSuccess";
import PaymentCancel from "@/pages/public/PaymentCancel";
import AuthCallback from "@/pages/public/AuthCallback";
import Account from "@/pages/public/Account";
import Culture from "@/pages/public/Culture";
import Charter from "@/pages/public/Charter";
import Store from "@/pages/public/Store";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import CRM from "@/pages/admin/CRM";
import Projects from "@/pages/admin/Projects";
import Media from "@/pages/admin/Media";
import Analytics from "@/pages/admin/Analytics";
import Inbox from "@/pages/admin/Inbox";
import Grants from "@/pages/admin/Grants";
import Campaigns from "@/pages/admin/Campaigns";
import Partnerships from "@/pages/admin/Partnerships";
import Populate from "@/pages/admin/Populate";
import Programs from "@/pages/admin/Programs";
import EconomicCommons from "@/pages/admin/EconomicCommons";
import Content from "@/pages/admin/Content";
import Archive from "@/pages/admin/Archive";
import Curriculum from "@/pages/admin/Curriculum";
import Staff from "@/pages/admin/Staff";
import StaffWorkspacePage from "@/pages/admin/StaffWorkspacePage";
import Doctrine from "@/pages/admin/Doctrine";
import Discovery from "@/pages/admin/Discovery";
import Execution from "@/pages/admin/Execution";
import LivingCalendar from "@/pages/admin/LivingCalendar";
import People from "@/pages/admin/People";
import Sanctuary from "@/pages/admin/Sanctuary";
import StoryMedia from "@/pages/admin/StoryMedia";
import InstitutionalProfile from "@/pages/admin/InstitutionalProfile";
import InstitutionalSettings from "@/pages/admin/InstitutionalSettings";
import Maintenance from "@/pages/admin/Maintenance";

const withPublic = (El) => <PublicLayout><El /></PublicLayout>;
const withAdmin = (El) => <ProtectedRoute><AdminLayout><El /></AdminLayout></ProtectedRoute>;

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={withPublic(Home)} />
          <Route path="/about" element={withPublic(About)} />
          <Route path="/rebirthing" element={withPublic(Rebirthing)} />
          <Route path="/retreats" element={withPublic(Retreats)} />
          <Route path="/retreats/:id" element={withPublic(RetreatDetail)} />
          <Route path="/dubbi" element={withPublic(Dubbi)} />
          <Route path="/culture" element={withPublic(Culture)} />
          <Route path="/charter" element={withPublic(Charter)} />
          <Route path="/volunteer" element={withPublic(Volunteer)} />
          <Route path="/contact" element={withPublic(Contact)} />
          <Route path="/donate" element={withPublic(Donate)} />
          <Route path="/store" element={withPublic(Store)} />
          <Route path="/payment/success" element={withPublic(PaymentSuccess)} />
          <Route path="/payment/cancel" element={withPublic(PaymentCancel)} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/account" element={withPublic(Account)} />

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={withAdmin(Dashboard)} />
          <Route path="/admin/crm" element={withAdmin(CRM)} />
          <Route path="/admin/projects" element={withAdmin(Projects)} />
          <Route path="/admin/media" element={withAdmin(Media)} />
          <Route path="/admin/analytics" element={withAdmin(Analytics)} />
          <Route path="/admin/inbox" element={withAdmin(Inbox)} />
          <Route path="/admin/grants" element={withAdmin(Grants)} />
          <Route path="/admin/campaigns" element={withAdmin(Campaigns)} />
          <Route path="/admin/partnerships" element={withAdmin(Partnerships)} />
          <Route path="/admin/populate" element={withAdmin(Populate)} />
          <Route path="/admin/programs" element={withAdmin(Programs)} />
          <Route path="/admin/economic-commons" element={withAdmin(EconomicCommons)} />
          <Route path="/admin/content" element={withAdmin(Content)} />
          <Route path="/admin/archive" element={withAdmin(Archive)} />
          <Route path="/admin/curriculum" element={withAdmin(Curriculum)} />
          <Route path="/admin/staff" element={withAdmin(Staff)} />
          <Route path="/admin/staff/:id/workspace" element={withAdmin(StaffWorkspacePage)} />
          <Route path="/admin/doctrine" element={withAdmin(Doctrine)} />
          <Route path="/admin/discovery" element={withAdmin(Discovery)} />
          <Route path="/admin/execution" element={withAdmin(Execution)} />
          <Route path="/admin/living-calendar" element={withAdmin(LivingCalendar)} />
          <Route path="/admin/people" element={withAdmin(People)} />
          <Route path="/admin/sanctuary" element={withAdmin(Sanctuary)} />
          <Route path="/admin/story-media" element={withAdmin(StoryMedia)} />
          <Route path="/admin/institutional-profile" element={withAdmin(InstitutionalProfile)} />
          <Route path="/admin/institutional-settings" element={withAdmin(InstitutionalSettings)} />
          <Route path="/admin/maintenance" element={withAdmin(Maintenance)} />
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
